import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/components/htmlContent/HTMLContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/components/layouts/Banner/BannerSkeleton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/containers/components/layouts/Banner/components/MobileBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/components/layouts/DualLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/website/hotel/results-v2/HotelResultsV2Container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/website/hotel/results/hotelResultsBody/HotelResultsLoadingOverlay.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/containers/website/hotel/results/hotelResultsBody/mainContent/components/HotelList.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/components/AppErrorNotice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/common/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/common/breadCrumb/BreadCrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/common/breadCrumb/BreadCrumbSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/common/CollapsibleContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/filters/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/JsonLd.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/components/searchTab/components/tabs/hotel/HotelTab.tsx");
